import React, { Component } from 'react';
import { connect } from "react-redux";
import EffectComponents from 'components/effects/EffectsComponent.js';
import EffectsPaneSidebar from 'components/mix/EffectsPaneSidebar.js';
import MixTrackParametersView from 'components/mix/MixTrackParametersView.js';
import {IS_GROUP} from 'components/mix/constants.js';
import {IS_TRACK} from 'components/mix/constants.js';
import {IS_SEND} from 'components/mix/constants.js';
import {TRACK} from 'components/mix/constants.js';
import {EFFECTS} from 'components/mix/constants.js';

class MixEffectsPane extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getEffectsTrack() {
        let track = this.props.selectedGroup !== undefined ? this.props.selectedGroup :
            this.props.sequencerEngine.tracks[this.props.selectedTrack];
        return track;
    }

    getEffectsTrackIf(type) {
        let sends = this.props.sequencerEngine.sends.sends;
        if (type === IS_TRACK) {
            if (typeof(this.props.selectedTrack) === 'number') {
                return this.props.sequencerEngine.tracks[this.props.selectedTrack];
            }
            return this.props.selectedTrack;
        } else if (
            type == IS_GROUP &&
                sends.indexOf(this.props.selectedGroup) == -1) {
            return this.props.selectedGroup;
       }  else if (type == IS_SEND &&
                    sends.indexOf(this.props.selectedGroup) > -1) {
            return this.props.selectedGroup;
        }
        return undefined;
    }

    onEffectsChange() {
        let track = this.getEffectsTrack();
        if (track !== undefined) {
            track.updateEffects();
        }
    }

    render() {
        if (this.props.effectsPaneOption === TRACK) {
            return (
            <div className="effects-pane">
              <EffectsPaneSidebar/>
              <MixTrackParametersView
                sequencerEngine={this.props.sequencerEngine}
                track={this.props.sequencerEngine.tracks[this.props.selectedTrack]}/>
            </div>
            );
        } else if (this.props.hide) {
            return (
                <div className="effects-pane hide">
                  <EffectsPaneSidebar/>
                </div>
            );
        }

        return (
            <div className="effects-pane">
              <EffectsPaneSidebar/>
              {this.getEffectsTrack(IS_TRACK) !== undefined || this.getEffectsTrack(IS_SEND) !== undefined ||
                  this.getEffectsTrack(IS_GROUP) ? 
                  <EffectComponents.EffectsView
                    store={this.props.sequencerEngine.store}
                    sequencerEngine={this.props.sequencerEngine}
                    onParameterChanged={(parameter) => this.props.onParameterChanged(parameter)}
                    onEffectsChange={() => this.onEffectsChange()}
                    panning={0}
                    onChangePanning={(i) => console.log('panning changed = ' + i)}
                    sends={this.props.sequencerEngine.sends}
                    tracks={this.props.sequencerEngine.tracks}
                    track={this.getEffectsTrackIf(IS_TRACK)}
                    send={this.getEffectsTrackIf(IS_SEND)}
                    group={this.getEffectsTrackIf(IS_GROUP)}/> : ''}
              </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        selectedGroup: state.mix.selectedGroup,
        selectedTrack: state.mix.selectedTrack,
        effectsPaneOption: state.mix.effectsPaneOption,
        currentSubSequence: state.sequencer.currentSubSequence[props.sequencerEngine.engineId],
    };
};

export default connect(mapStateToProps, null)(MixEffectsPane);
